export default __webpack_public_path__ + "static/media/dot-pending.a92335c5.svg";